import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => (
  <header className="header">
    <h1 className="logo">
      <Link to="/">Hestia Ledger</Link>
    </h1>
    <nav>
      <Link to="/about">About</Link>
      <Link to="/features">Features</Link>
      <Link to="/services">Services</Link>
      <a href="http://app.hestialedger.com">Try It</a>
      <Link to="/support">Support</Link>
    </nav>
  </header>
);

export default Header;